import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/Productsemptystate.png'


const _withScopeId = n => (_pushScopeId("data-v-6cc43a02"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "sentence-case" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_DxpShopifyImg = _resolveComponent("DxpShopifyImg")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")!
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_menu_button)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("Products")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, { onClick: _ctx.openActiveJobs }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        color: _ctx.isJobPending ? "warning" : "",
                        icon: _ctx.hourglass,
                        slot: "icon-only"
                      }, null, 8, ["color", "icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        ref: "contentRef",
        "scroll-events": true,
        onIonScroll: _cache[4] || (_cache[4] = ($event: any) => (_ctx.enableScrolling()))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_searchbar, {
            onIonFocus: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectSearchBarText($event))),
            placeholder: _ctx.$t('Search products'),
            modelValue: _ctx.queryString,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.queryString) = $event)),
            onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.getProducts()), ["enter"]))
          }, null, 8, ["placeholder", "modelValue"]),
          (_ctx.products.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.hasQuery)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.$t("No results found")), 1))
                  : _createCommentVNode("", true),
                _hoisted_3,
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("Enter a product name, style name, SKU, UPCA or external ID.")), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
                  return (_openBlock(), _createBlock(_component_ion_item, {
                    key: product.groupValue,
                    lines: "none",
                    onClick: () => _ctx.router.push({ name: 'Product-details', params: { id: product.groupValue }})
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_thumbnail, { slot: "start" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxpShopifyImg, {
                            src: _ctx.getProduct(product.groupValue).mainImageUrl,
                            size: "small"
                          }, null, 8, ["src"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.getProduct(product.groupValue).productName), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.$filters.groupFeatures(_ctx.getProduct(product.groupValue).featureHierarchy)), (attribute, feature) => {
                            return (_openBlock(), _createElementBlock("p", { key: attribute }, [
                              _createElementVNode("span", _hoisted_5, _toDisplayString(feature), 1),
                              _createTextVNode(": " + _toDisplayString(attribute), 1)
                            ]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_badge, {
                        slot: "end",
                        color: "success"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(product.doclist.numFound) + " " + _toDisplayString(_ctx.$t("pieces preordered")), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128)),
                _withDirectives(_createVNode(_component_ion_infinite_scroll, {
                  onIonInfinite: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadMoreProducts($event))),
                  threshold: "100px",
                  id: "infinite-scroll",
                  ref: "infiniteScrollRef"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_infinite_scroll_content, {
                      "loading-spinner": "crescent",
                      "loading-text": _ctx.$t('Loading')
                    }, null, 8, ["loading-text"])
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.isScrolleable]
                ])
              ]))
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }))
}